import get from "lodash/get";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { DfpComponent } from "../../ads/dfp-component";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";
import { appendGoogleTagServices } from "../utils";

import "./top-sticky-ad.m.css";

export const TopStickyAd = () => {
  const showAd = {
    display: "block",
  };
  const hideAd = {
    display: "none",
  };

  const [currentState, setCurrentState] = useState("");
  const [placeholder, setPlaceholder] = useState(hideAd);
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const topStickyAdConfig = get(qtState, ["config", "ads-config", "slots", "top_sticky_ad"], {});
  const adsConfig = get(qtState, ["config", "ads-config", "dfp_ads"], {});
  const enableAds = get(adsConfig, ["enable_ads"], null);
  const loadAdsSynchronously = get(adsConfig, ["load_ads_synchronously"], null);
  const currentPath = get(qtState, ["currentPath"], null);

  useEffect(() => {
    if (enableAds && !loadAdsSynchronously) {
      setTimeout(function () {
        appendGoogleTagServices();
      }, 7 * 1000);
    }
  }, []);

  useEffect(() => {
    if (window.googletag && window.googletag.apiReady) {
      // check if the API is ready
      window.googletag.cmd.push(function () {
        if (window.googletag.pubadsReady) {
          // detect whether PubAdsService is fully loaded
          window.googletag.pubads().refresh();
        }
      });
    }
    if (currentState !== currentPath) {
      setTimeout(function () {
        setCurrentState(currentPath);
        setPlaceholder(showAd);
      }, 7 * 1000);
    }
  }, [currentPath]);

  const toggleAd = () => {
    setPlaceholder(hideAd);
  };

  return (
    <div styleName="wrapper" style={placeholder} className="top-sticky-ad-wrapper">
      <div onClick={toggleAd}>
        <SvgIconHandler
          iconStyle={{ color: "#000" }}
          className="close-icon"
          type="close"
          width="20"
          height="20"
          viewBox="0 0 12 12"
        />
      </div>
      <DfpComponent
        adStyleName="top-sticky-ad"
        id="top-sticky-ad-id"
        path={topStickyAdConfig.ad_unit}
        size={topStickyAdConfig.sizes}
        viewPortSizeMapping={topStickyAdConfig.view_port_size_mapping}
      />
    </div>
  );
};
